import { I18n } from "@assets/strings";
import { Range } from "immutable";
import React from "react";
import { Link } from "react-router";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { Group } from "@domain/group/group";
// import { useSubscriptionsInPeriod } from "../../../../../domain/group/hooks";
// import {  Period } from "../../../../../domain/group/shareroom/shareroom";
import { useShareroomLastFiveMembers } from "@domain/user/hooks";
import { useIsMobile } from "@utils/hooks";
import { mobile } from "@ui/styles/utils";
//import { BarChart } from "../../../charts/barChart";
// import { ChartBar } from "../../../charts/chartBar";
import { Smalldescription } from "@ui/components/containers/description";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { Subtitle } from "@ui/components/containers/title";
// import { Selecter } from "../../../inputs/selecter";
import chartSvg from "@assets/images/chart.svg";
import histoSvg from "@assets/images/histo.svg";
import { Row, Stack, stack } from "@ui/components/layout";
import { UserDetailedView } from "@ui/components/profile/userDetailedView";
import { CustomUserViewSkeleton } from "@ui/components/profile/userView";
import { LargeTextSkeleton } from "@ui/components/skeleton/basicSkeletons";

interface DashboardHomeDetailsProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}

export const DashboardHomeDetails: React.FC<DashboardHomeDetailsProps> = ({ shareroom, ...htmlProps }) => {
	const isMobile = useIsMobile();
	// const [period, setPeriod] = useState<Period>("TWELVEMONTHS");

	const { result: members, loading: lastFiveLoading } = useShareroomLastFiveMembers(shareroom.id);
	//const { result: data } = useSubscriptionsInPeriod(shareroom.id, period);
	// console.log("data", data);

	return (
		<Container {...htmlProps}>
			<Row align="flex-start" justify="space-between" style={{ width: "100%" }}>
				<Stack gap={10}>
					<Subtitle>{I18n.t("shareroom.dashboard.general.all_learners.title")}</Subtitle>
					<Smalldescription>{I18n.t("shareroom.dashboard.general.audience.description")}</Smalldescription>
				</Stack>
				{!isMobile ? (
					<Row gap={10}>
						{shareroom.license === "PREMIUM" ? null : (
							// <Selecter
							// 	value={period}
							// 	options={allPeriods.map((period) => ({ label: I18n.t(`filter.${period}`), value: period }))}
							// 	onChange={(value) => setPeriod(value as Period)}
							// />
							<>
								<LargeTextSkeleton height={24} />
								<LargeTextSkeleton height={24} />
							</>
						)}
					</Row>
				) : null}
			</Row>
			{shareroom.license === "PREMIUM" ? (
				<HistoBlocPremium>
					<img src={chartSvg} />
					<EmptyMessage>{I18n.t("shareroom.dashbaord.general.chart.description")}</EmptyMessage>
				</HistoBlocPremium>
			) : (
				<HistoBlocFree>
					<img src={histoSvg} />
				</HistoBlocFree>
			)}
			<LastMember>
				<Stack gap={10}>
					<Subtitle>{I18n.t("shareroom.dashboard.general.recent_learners.description")}</Subtitle>
					<Smalldescription>{I18n.t("shareroom.dashboard.general.last_learners.descrption")}</Smalldescription>
				</Stack>
				<>
					{lastFiveLoading ? (
						<ClipLoader />
					) : (
						<>
							{!members.length ? (
								<Row justify="space-between" align="center" style={{ width: "100%" }}>
									{Range(0, 5).map((value) => (
										<CustomUserViewSkeleton key={value} gap={5} pictureSize={40} />
									))}
								</Row>
							) : (
								<Row
									gap={30}
									justify={members.length !== 5 ? "flex-start" : "space-between"}
									align="center"
									style={{ width: "100%" }}
								>
									{members.map((member) => (
										<Link key={member.id} to={Path.Profile(member)}>
											<UserDetailedView user={member} size={isMobile ? "M" : "L"} />
										</Link>
									))}
								</Row>
							)}
						</>
					)}
				</>
			</LastMember>
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	padding: 30px 44px;
	border: none;
	${stack(70)}
	width: 100%;
`;

const HistoBlocFree = styled.div`
	${stack(20)};
	width: 100%;
	> img {
		width: 100%;
	}
`;

const HistoBlocPremium = styled.div`
	${stack(20, "center", "center")};
	width: 100%;
	> img {
		width: 400px;
	}
`;

const LastMember = styled.div`
	${stack(20)}
	width: 100%;
`;

const EmptyMessage = styled.div`
	font-weight: 400;
	font-size: 16px;
	line-height: 26px;
	color: rgba(1, 1, 1, 0.5);
	margin-top: 20px;
	@media ${mobile} {
		font-size: 13px;
	}
`;
